<ng-container>
  <div id="header-inner" class="max-xl:shadow-xl xl:shadow-md py-[1.06rem] fixed bg-white left-0 w-full">
    <div class="container flex justify-between items-center">
      <a class="flex xl:hidden items-center justify-center rounded-lg" (click)="toggleMenu()">
        <svg-icon key="menu2Icon" fontSize="24px" class="text-gray-700 hover:text-primary-500"></svg-icon>
      </a>

      <div class="logo flex items-center">
        <a routerLink="/" class="btn-filled grad-ltd mr-6">
          <img width="164px" height="28px" src="./assets/images/logo.svg" />
        </a>
      </div>
      
      <!-- icon mobile -->
      <a class="flex xl:hidden items-center justify-center rounded-lg">
        <svg-icon key="userIcon" fontSize="24px" class="text-gray-700 hover:text-primary-500"></svg-icon>
      </a>

      <franbase-main-menu class="main-menu rounded-lg max-xl:pt-4 max-xl:pb-4 max-xl:space-y-4 max-xl:px-4 max-xl:fixed max-xs:max-w-full max-xl:max-w-[300px] max-xl:shadow-xl xl:relative max-xl:left-0 max-xl:top-[0] w-full max-xl:h-[100vh] flex max-xl:flex-col xl:flex-row xl:justify-between items-center transition duration-300 [&>a:not(:last-child)]:mr-12 [&>a]:flex [&>a]:items-center [&>a]:text-gray-900 [&>a]:hover:text-gray-800 max-xl:z-30 max-xl:overflow-y-auto bg-white z-50 {{ menuIsVisible ? 'show' : 'hide' }}" (handleMenu)="closeMenu($event)"></franbase-main-menu>
    </div>
  </div>
</ng-container>
